import CryptoJS from 'crypto-js';

/**
 * Derive a 16‑character secret from a given source string.
 * Algorithm (as provided): secret = first 16 chars of hex(SHA-256(source + source + source))
 */
export function generateSecret(source) {
  const base = `${source || ''}${source || ''}${source || ''}`;
  const hashHex = CryptoJS.SHA256(base).toString(CryptoJS.enc.Hex);
  return hashHex.substring(0, 16);
}

/**
 * Decrypt AES‑CBC (PKCS#7) ciphertext using CryptoJS where both key and IV
 * are the same 16‑byte value derived externally (legacy scheme).
 *
 * @param {string} encB64 Base64-encoded ciphertext (without "Salted__" header)
 * @param {string} secretKey 16‑character ASCII secret (output of generateSecret)
 * @returns {string} UTF‑8 decoded plaintext
 */
export function decryptAesCbc(encB64, secretKey) {
  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const iv = CryptoJS.enc.Utf8.parse(secretKey);
  const ciphertext = CryptoJS.enc.Base64.parse(encB64);
  const decrypted = CryptoJS.AES.decrypt({ ciphertext }, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Utf8.stringify(decrypted);
}


